import { defineStyleConfig } from '@chakra-ui/styled-system';

const ButtonTheme = defineStyleConfig({
  baseStyle: {
    borderRadius: 'full',
    fontWeight: '500',
  },
  sizes: {
    sm: {
      height: '32px',
      px: '16px',
      fontSize: '14px',
      width: 'auto',
    },
    md: {
      height: '40px',
      px: '16px',
      fontSize: '16px',
      width: 'auto',
    },
    lg: {
      height: '48px',
      px: '24px',
      fontSize: '18px',
      width: 'auto',
    },
  },
  variants: {
    primary: {
      background: 'primaryBlack',
      color: 'white',
      _hover: {
        color: 'primary',
      },
      _active: {
        color: 'textGray',
      },
    },
    secondary: {
      border: '1px solid',
      borderColor: 'primaryBlack',
      color: 'primaryBlack',
      _hover: {
        bg: 'primary',
      },
      _active: {
        color: '#14141466',
      },
    },
    tertiary: {
      bg: '#eaeaea',
      _hover: {
        bg: 'primary',
      },
      _active: {
        bg: '#14141429',
        color: '#14141466',
      },
    },
    outline: {
      background: '#fff',
      border: '1px solid #000',
      color: '#000',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-in-out',
      _hover: {
        background: 'linear-gradient(#f5e003, #e5b611)',
      },
    },
    ButtonWithIcon: {
      bg: '#FFFFFF',
      color: '#111011',
      display: 'flex',
      height: 'auto',
      px: '12px',
      py: '6px',
      alignItems: 'center',
      borderRadius: '6px',
      transition: 'all 0.2s ease-in-out',
      border: '1px solid #EDEDED',
      _hover: {
        bg: '#111011',
        color: '#fff',
      },
      _active: {
        transform: 'scale(0.95)',
        transition: 'transform 0.2s ease',
      },
    },
    warning: {
      background: 'red',
      color: 'white',
      _hover: {
        color: 'primary',
      },
      _active: {
        color: 'textGray',
      },
    },
    field: {
      p: '0.5rem 0.75rem',
      lineHeight: 1,
      bg: 'input.bg',
      borderRadius: '12px',
      border: '1px solid transparent',
      _focus: {
        boxShadow: 'outline',
        borderColor: 'gray.300',
      },
      _hover: {
        borderColor: 'gray.300',
      },
      _active: {
        color: 'white',
        bg: 'black',
        borderColor: 'black',
        '*': {
          color: 'white',
        },
      },
    },
    link: {
      pb: '0.2rem',
      fontWeight: '400',
      color: 'primaryScheme.600',
      textDecoration: 'underline',
    },
    chip: {
      px: '10px',
      py: '2px',
      borderRadius: 'full',
      fontSize: '10px',
      fontWeight: 500,
      height: 'auto',
      border: '1px solid border',
      bg: 'white',
      color: 'textBlack',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      transition: 'all 120ms',
      _hover: {
        borderColor: 'border',
        bg: 'input.bg',
      },
      _active: {
        borderColor: 'textBlack',
        bg: 'textBlack',
        color: 'white',
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'primary',
  },
});

export default ButtonTheme;
